<p-toast />
<p-confirmDialog />
<div class="px-6 py-4">
  <div class="flex justify-content-between mb-4">
    <p class="text-xl font-semibold">{{ 'layout.configurations.menu.roles' | translate }}</p>
    
    <p-button
      *emPermission="Permission.CONFIG_USER_MANAGEMENT"
      class="p-button-success"
      icon="pi pi-plus"
      severity="success"
      (onClick)="onAdd()"></p-button>
  </div>
  <p-table [value]="roles" styleClass="w-full p-datatable-sm">
    <ng-template pTemplate="header">
      <tr>
        <th scope="col" pSortableColumn="name" class="bg-white">
          {{ 'layout.configurations.roles.name' | translate }} <p-sortIcon field="name" />
        </th>
        <th scope="col" pSortableColumn="description" class="bg-white">
          {{ 'layout.configurations.roles.description' | translate }} <p-sortIcon field="description" />
        </th>
        <th *emPermission="Permission.CONFIG_USER_MANAGEMENT" scope="col" class="bg-white w-10rem pl-3">
          {{ 'layout.configurations.roles.actions' | translate }}
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-role>
      <tr [ngClass]="{ 'super-admin-row': role.isSuperAdmin }">
        <td>{{ role.name }}</td>
        <td>{{ role.description }}</td>
        <ng-container *emPermission="Permission.CONFIG_USER_MANAGEMENT">
          <td>
            <p-button
              *ngIf="!role.isSuperAdmin"
              icon="pi pi-pencil"
              [outlined]="true"
              class="mr-2"
              (onClick)="onEdit(role)"></p-button>
            <p-button
              *ngIf="!role.isSuperAdmin"
              icon="pi pi-trash"
              severity="danger"
              [outlined]="true"
              (onClick)="onDelete($event, role.id)"></p-button>
          </td>
        </ng-container>
      </tr>
    </ng-template>
  </p-table>
</div>
